import { render, staticRenderFns } from "./BuilderStartup.vue?vue&type=template&id=291cb1a6&"
import script from "./BuilderStartup.vue?vue&type=script&lang=js&"
export * from "./BuilderStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports